<template>
  <div>
    <b-row
      class="m-1"
    >
      <b-col
        class="text-left"
        md="3"
        lg="3"
      >
        <copy-snippet
          snippet-id="copy-bc-case-id"
          label="BC CASE ID"
          :value="bcCaseId ? bcCaseId.toString() : 'N/A'"
        />
        <copy-snippet
          snippet-id="copy-case-id"
          label="CASE ID"
          :value="prefixCaseId ? prefixCaseId : caseId"
        />
      </b-col>
      <!-- <b-col
        class="text-right"
        md="9"
        lg="9"
      >
        <b-button-group>
          <header-buttons
            :bc-case-id="bcCaseId"
            :case-status="caseStatus"
            :case-state-data="caseStateData"
            :case-state="caseState"
          />
        </b-button-group>
      </b-col> -->
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol,
  // BButtonGroup,
} from 'bootstrap-vue'
// import store from '@/store'
import CopySnippet from './CopySnippet.vue'
// import HeaderButtons from './HeaderButtons.vue'

export default {
  components: {
    BRow,
    BCol,
    CopySnippet,
    // HeaderButtons,
    // BButtonGroup,
  },
  // setup() {
  //   const {
  //     bcCaseId, caseId, caseStatus, prefixCaseId,
  //   } = store.state['case-details']
  //   return {
  //     bcCaseId,
  //     caseId,
  //     caseStatus,
  //     prefixCaseId,
  //   }
  // },
  props: {
    bcCaseId: {
      type: String,
      required: true,
    },
    caseStatus: {
      type: Number,
      required: true,
    },
    prefixCaseId: {
      type: [String, null],
      required: true,
    },
    caseStateData: {
      type: Object,
      required: true,
    },
    caseState: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      caseId: this.$route.params.id,
    }
  },
}
</script>

<style lang="scss">
</style>
